import { Injectable } from '@angular/core';
import { AlertButton } from '@ionic/core';
import { ShowMessageParamsPopup } from '@osapp/services/interfaces/ShowMessageParamsPopup';
import { UiMessageService } from '@osapp/services/uiMessage.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class IdlActionButtonService {

	//#region METHODS

	constructor(private isvcUiMessage: UiMessageService) { }

	/** Affiche un avertissement à l'utilisateur indiquant que des "traitements/conversations" sont déjà en cours pour ce patient.
	 * @param psMessage Message à afficher.
	 * @param paButtons Liste de boutons personnalisés.
	 */
	public warningCreationFromActionButton(psMessage: string, paButtons?: AlertButton[]): Observable<boolean> {
		this.isvcUiMessage.showMessage(new ShowMessageParamsPopup({ message: psMessage, header: "Attention", buttons: paButtons }));
		return of(false);
	}

	//#endregion
}